//Academics SubMenu Pages
import RouteItem from ".";
import AcademicSchedule from "../pages/academics/AcademicSchedule";
import Committe from "../pages/academics/Committe";
import LectureTimeTable from "../pages/academics/LectureTimeTable";
import Syllabus from "../pages/academics/Syllabus";

export const academicRoutes: RouteItem = {
  key: "router-academics",
  title: "Academics",
  tooltip: "Academics",
  path: "/academics",
  enabled: true,
  appendDivider: true,
  showInHeader: true,
  subRoutes: [
    {
      key: "router-academics-schedules",
      title: "Academic Schedules",
      tooltip: "Academic Schedules",
      path: "academic-scehdules",
      enabled: true,
      component: AcademicSchedule,
      appendDivider: true,
    },
    {
      key: "router-academics-lecture-time-tables",
      title: "Lecture Time Tables",
      tooltip: "Lecture Time Tables",
      path: "lecture-time-tables",
      enabled: true,
      component: LectureTimeTable,
      appendDivider: true,
    },
    {
      key: "router-academics-committees",
      title: "Committees",
      tooltip: "Committees",
      path: "committees",
      enabled: true,
      component: Committe,
      appendDivider: true,
    },
    // {
    //   key: "router-academics-faculty",
    //   title: "Faculties",
    //   tooltip: "Faculties",
    //   path: "faculties",
    //   enabled: true,
    //   component: Faculty,
    //   appendDivider: true,
    // },
    // {
    //   key: "router-academics-faculty-achievement",
    //   title: "Faculty Achievement",
    //   tooltip: "Faculty Achievement",
    //   path: "faculty-achievement",
    //   enabled: true,
    //   component: FacultyAchievement,
    //   appendDivider: true,
    // },

    {
      key: "router-academics-syllabus",
      title: "Syllabus",
      tooltip: "Syllabus",
      path: "syllabus",
      enabled: true,
      component: Syllabus,
      appendDivider: true,
    },
  ],
};
